export default __webpack_public_path__ + "static/personal-car-and-motor-loans-c09e7a2ec3a85b7e99c99131322dee2f.png";